import PropTypes from 'prop-types'
import loadingGif from '../../assets/icons/loading.gif'
import './loading.scss'

const LoadingSpinner = ({ size }) => {
  return (
    <div className={`loading-spinner ${size}`}>
      <img src={loadingGif} alt="loading" />
    </div>
  )
}

export default LoadingSpinner

LoadingSpinner.defaultProps = {
  size: '',
}
LoadingSpinner.propTypes = {
  size: PropTypes.string,
}
